//import debugLib from '../vendor/debug';

// function callstack() {
//   let stack = [];
//   let named = 0;
//   let caller = callstack.caller && callstack.caller.caller;

//   while (caller && named < 3 && stack.length < 8) {
//     stack.push(caller.name || '‥');
//     if (caller.name) {
//       named++;
//     }

//     caller = caller.caller;
//   }

//   if (!named) {
//     return '';
//   }

//   return `at ${stack.join('/')}`;
// }

function debug(name) {
  // let dbg = debugLib(name);

  function log(...args) {
    // dbg(...args, callstack());
  }

  return log;
}

export default debug;
